import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export const SITE_URL = 'https://www.alprofessor.ae';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/inspection-car.png`;

const urlFor = (lang, path) => (path ? `${SITE_URL}/${lang}/${path}` : `${SITE_URL}/${lang}/`);

/**
 * Shared canonical/hreflang/OG/Twitter head tags for a bilingual public page.
 * `path` is the route segment after the /:lang/ prefix, e.g. "services/pre-purchase-inspections"
 * (omit or pass "" for the homepage).
 */
const SeoHead = ({ path = '', title, description, keywords, image = DEFAULT_OG_IMAGE, jsonLd }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'ar';
  const cleanPath = path.replace(/^\/+|\/+$/g, '');

  return (
    <Helmet htmlAttributes={{ lang, dir: lang === 'ar' ? 'rtl' : 'ltr' }}>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={urlFor(lang, cleanPath)} />
      <link rel="alternate" hrefLang="ar" href={urlFor('ar', cleanPath)} />
      <link rel="alternate" hrefLang="en" href={urlFor('en', cleanPath)} />
      <link rel="alternate" hrefLang="x-default" href={urlFor('ar', cleanPath)} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Al Professor Car Inspection" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={urlFor(lang, cleanPath)} />
      <meta property="og:locale" content={lang === 'ar' ? 'ar_AE' : 'en_AE'} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default SeoHead;
